var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEasyDifficultyLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#FFF3E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.34782 18.4348V14.0522C8.34782 13.4783 7.87826 13.0087 7.30434 13.0087C6.73043 13.0087 6.26086 13.4783 6.26086 14.0522V18.4348C6.26086 19.0087 6.73043 19.4783 7.30434 19.4783C7.87826 19.4783 8.34782 19.0087 8.34782 18.4348Z",
    fill: "#FAA53D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6522 18.4345C15.6522 19.0084 16.1218 19.478 16.6957 19.478C17.2696 19.478 17.7392 19.0084 17.7392 18.4345V5.56496C17.7392 4.99105 17.2696 4.52148 16.6957 4.52148C16.1218 4.52148 15.6522 4.99105 15.6522 5.56496V18.4345Z",
    fill: "#FFD39E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0435 9.80844V18.4345C13.0435 19.0084 12.5739 19.478 12 19.478C11.4261 19.478 10.9565 19.0084 10.9565 18.4345V9.80844C10.9565 9.23453 11.4261 8.76496 12 8.76496C12.5739 8.76496 13.0435 9.23453 13.0435 9.80844Z",
    fill: "#FFD39E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyDifficultyLevel);
export default __webpack_public_path__ + "static/media/easy-difficulty-level.eff780ce59b12f60d5fe5170b280c709.svg";
export { ForwardRef as ReactComponent };